import { render, staticRenderFns } from "./Cfiscales.vue?vue&type=template&id=40fa8226"
import script from "./Cfiscales.vue?vue&type=script&lang=ts"
export * from "./Cfiscales.vue?vue&type=script&lang=ts"
import style0 from "./Cfiscales.vue?vue&type=style&index=0&id=40fa8226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports